import Requester from '../components/Requester';
import urlConfig from '../config/urlConfig';
import constants from '../utils/constants';
import helpers from '../utils/helpers';

export default {
  getChatThreads: () => Requester(helpers.createRequesterOptions(urlConfig.chat.getChatThreads, constants.requestType.get)),
  getChatMessages: (model) => Requester(helpers.createRequesterOptions(urlConfig.chat.getChatMessages, constants.requestType.post, model)),
  sendMessage: (model) => Requester(helpers.createRequesterOptions(urlConfig.chat.sendMessage, constants.requestType.post, model)),
  getUnReadedMessageCount: () => Requester(helpers.createRequesterOptions(urlConfig.chat.getUnReadedMessageCount, constants.requestType.get)),
  setReadedThread: (model) => Requester(helpers.createRequesterOptions(urlConfig.chat.setReadedThread, constants.requestType.post, model)),
  setUnreadAllThread: (model) => Requester(helpers.createRequesterOptions(urlConfig.chat.setUnreadAllThread, constants.requestType.post, model)),
};
